document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-button');
  const controlsMenu = document.querySelector('.controls-menu');
  const menuItems = document.querySelector('.menu-items');

  // Toggle menu visibility
  menuButton.addEventListener('click', () => {
    const isActive = controlsMenu.classList.toggle('active');
    menuButton.classList.toggle('tr-r-45');
    menuButton.setAttribute('aria-expanded', isActive);
    menuItems.setAttribute('aria-hidden', !isActive);
  });

  // Keyboard accessibility for menu button
  menuButton.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      menuButton.click();
    }
  });

  // Keyboard accessibility for menu items
  const menuButtons = document.querySelectorAll('.menu-item');
  menuButtons.forEach(button => {
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        button.click();
      }
    });
  });
});
